import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { Container, Col, Row, breakpointsMax } from "../res/styles/Common"
import { useMediaQuery } from "react-responsive"
import { menu, cancel } from "../res/imgs/icons"
import { NavItemD, NavItemM } from "../Atoms/NavItem"
import { Transition } from "react-transition-group"
import { pathnames } from "../config"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"

const Nb = styled.div`
    position: sticky;
    position: "-webkit-sticky";
    top: 0;
    background-color: ${(props) => (props.scrolled ? "white" : "transparent")};
    z-index: 1;
`

const MenuIcon = styled.img`
    width: 24px;
    height: 24px;
`

function Navbar(props) {
    const isMobile = useMediaQuery({ query: breakpointsMax.tablet })
    const [isMenuOpen, setMenuOpen] = useState(false)
    const [isScrolled, setScrolling] = useState(false)
    const [page, setPage] = useState(useLocation().pathname)
    const { t } = useTranslation()
    const transitionDuration = 0

    useEffect(() => {
        window.addEventListener("scroll", handleScroll)
        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    })

    const handleScroll = () => {
        if (window.pageYOffset > 0) setScrolling(true)
        else setScrolling(false)
    }

    const defaultStyle = {
        transition: `opacity ${transitionDuration}ms ease-in-out; max-height ${transitionDuration}ms ease-in-out`,
        opacity: 0,
        display: "inline-block",
        maxHeight: 0,
    }

    const transitionStyles = {
        entering: { opacity: 0, maxHeight: 0 },
        entered: { opacity: 1, maxHeight: "100%" },
    }

    const DesktopLayout = () => {
        return (
            <>
                <NavItemD
                    title={t("navbar.titles.home")}
                    link={pathnames[0]}
                    active={page === pathnames[0] ? true : false}
                    onClick={setPage}
                />
                <NavItemD
                    title={t("navbar.titles.cashmere")}
                    link={pathnames[1]}
                    active={page === pathnames[1] ? true : false}
                    onClick={setPage}
                />
                <NavItemD logo={props.logo} isImage={true} />
                <NavItemD
                    title={t("navbar.titles.products")}
                    link={pathnames[2]}
                    active={page === pathnames[2] ? true : false}
                    onClick={setPage}
                />
                <NavItemD
                    title={t("navbar.titles.contacts")}
                    link={pathnames[3]}
                    active={page === pathnames[3] ? true : false}
                    onClick={setPage}
                />
            </>
        )
    }

    const MobileLayout = () => {
        return (
            <>
                <NavItemD logo={props.logo} isImage={true} />
                <MenuIcon
                    src={isMenuOpen ? cancel : menu}
                    onClick={() => setMenuOpen(!isMenuOpen)}
                />
            </>
        )
    }

    const MobileSelector = () => {
        return (
            <Row>
                <Col>
                    <NavItemM
                        title={t("navbar.titles.home")}
                        link={pathnames[0]}
                        active={page === pathnames[0] ? true : false}
                        onClick={setPage}
                    />
                    <NavItemM
                        title={t("navbar.titles.cashmere")}
                        link={pathnames[1]}
                        active={page === pathnames[1] ? true : false}
                        onClick={setPage}
                    />
                    <NavItemM
                        title={t("navbar.titles.products")}
                        link={pathnames[2]}
                        active={page === pathnames[2] ? true : false}
                        onClick={setPage}
                    />
                    <NavItemM
                        title={t("navbar.titles.contacts")}
                        link={pathnames[3]}
                        active={page === pathnames[3] ? true : false}
                        onClick={setPage}
                    />
                </Col>
            </Row>
        )
    }

    return (
        <Nb scrolled={isScrolled || isMenuOpen}>
            <Col>
                <Container>
                    <Row>{isMobile ? <MobileLayout /> : <DesktopLayout />}</Row>
                </Container>
                {isMobile ? (
                    <Transition in={isMenuOpen} timeout={transitionDuration}>
                        {(state) => (
                            <div
                                style={{
                                    ...defaultStyle,
                                    ...transitionStyles[state],
                                }}
                            >
                                <MobileSelector />
                            </div>
                        )}
                    </Transition>
                ) : (
                    <></>
                )}
            </Col>
        </Nb>
    )
}

export default Navbar
